<template>
  <PlayerTournamentsList special />
</template>

<script>
import PlayerTournamentsList from './index.vue';
export default {
  name: 'SpecialEvents',
  components: { PlayerTournamentsList },
};
</script>
